import React from 'react'
import styles from './SearchableCard.scss'
import cx from 'classnames'

export class SearchableCard extends React.PureComponent {
  render () {
    const {keywords, onKeywordChange, children, className, chips, resultsCount, resultsLength, ...props} = this.props
    return (
      <div {...props} className={cx(styles.SearchableCard, className)}>
        <div className={styles.searchContainer}>
          <input
            spellCheck='false'
            type='text'
            className={styles.searchInput}
            placeholder='Search'
            value={keywords}
            onChange={onKeywordChange} />
          {chips && <div className={styles.chips}>
            {chips}
          </div>}
          {keywords &&
            resultsCount !== undefined &&
            resultsLength !== undefined &&
            <div className={styles.resultsCount}>
              Showing {resultsLength !== resultsCount && `1 - ${resultsLength} of `}{resultsCount} results
            </div>}
        </div>
        <div className={styles.resultsContainer}>
          {children}
        </div>
      </div>
    )
  }
}
